import {useTranslation} from "@i18n/client";
import React from "react";

import {I18nNamespace} from "@i18n";
import {useGetSchedulingRedirectUrl} from "../../../../useGetSchedulingRedirectUrl";
import Button from "../../Button";

type CompleteCheckInButtonProps = {
  appointmentId?: string;
  practiceId?: string;
};

const CompleteCheckInButton = ({appointmentId, practiceId}: CompleteCheckInButtonProps) => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const checkinUrl = useGetSchedulingRedirectUrl()({
    practiceId,
    preselectedApptId: appointmentId,
  });
  return (
    <div className="mt-6">
      <Button href={checkinUrl}>
        <span className="mx-2">{i18n.t("Check in now", {ns: "web-scheduling"})}</span>
      </Button>
    </div>
  );
};

export default React.memo(CompleteCheckInButton);
